import { CloudQueueOutlined } from '@mui/icons-material';
import { useIsWeatherAlerting } from 'features/weatherAlerts/hooks/useIsWeatherAlerting';

interface Props {
  analyzerId: number;
}

const WeatherAlertIcon = ({ analyzerId }: Props) => {
  const weatherAlerting = useIsWeatherAlerting(analyzerId);
  if (!weatherAlerting.warning && !weatherAlerting.caution) return null;
  return (
    <CloudQueueOutlined
      sx={{ color: weatherAlerting.warning ? 'red' : 'orange' }}
      fontSize='small'
    />
  );
};

export default WeatherAlertIcon;
